import { parseQueryParamsObject } from "@robe/core-utils";
import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { GetSubCategoryResponse } from "./getSubCategory";
import { fillMissingLocalizedCategoryNames } from "./utils";

export const getSubCategoriesByIds = (ids: number[], core: XcoreCore): BaseApiRequest<GetSubCategoryResponse[]> =>
  core
    .fetch(`/api/category/subcategories${parseQueryParamsObject({ ids })}`)
    .then((res) => res.json())
    .then((res: GetSubCategoryResponse[]) =>
      res.map((item) => ({
        topLevelCategory: item.topLevelCategory,
        subCategory: fillMissingLocalizedCategoryNames(item.subCategory),
      }))
    );
